export const OpsgenieMarkBrand = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.9991 23.964C29.1491 23.964 33.3241 19.789 33.3241 14.639C33.3241 9.48891 29.1491 5.31396 23.9991 5.31396C18.849 5.31396 14.6741 9.48891 14.6741 14.639C14.6741 19.789 18.849 23.964 23.9991 23.964Z"
      fill="url(#paint0_linear_818_517)"
    />
    <path
      d="M23.205 42.4589C17.115 38.5739 12.05 33.2789 8.43802 27.0229C8.15702 26.5189 8.33802 25.8819 8.84302 25.6009C8.85902 25.5919 8.87602 25.5829 8.89302 25.5749L15.955 22.1089C16.449 21.8679 17.045 22.0509 17.319 22.5269C20.889 28.5109 26.169 33.2899 32.478 36.2489C30.151 38.5929 27.574 40.6759 24.794 42.4589C24.308 42.7629 23.691 42.7629 23.205 42.4589Z"
      fill="url(#paint1_linear_818_517)"
    />
    <path
      d="M24.794 42.4589C30.885 38.5749 35.95 33.2799 39.561 27.0229C39.843 26.5189 39.663 25.8819 39.159 25.5999C39.143 25.5909 39.127 25.5829 39.111 25.5749L32.044 22.1089C31.55 21.8679 30.954 22.0509 30.68 22.5269C27.11 28.5119 21.831 33.2909 15.521 36.2489C17.846 38.5949 20.423 40.6779 23.205 42.4589C23.691 42.7629 24.308 42.7629 24.794 42.4589Z"
      fill="#1D7AFC"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_517"
        x1="23.9991"
        y1="8.41297"
        x2="23.9991"
        y2="27.561"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D7AFC" />
        <stop offset="0.82" stopColor="#0055CC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_818_517"
        x1="18.254"
        y1="27.0249"
        x2="24.668"
        y2="40.4489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D7AFC" />
        <stop offset="0.62" stopColor="#0055CC" />
      </linearGradient>
    </defs>
  </svg>
);
